import { Address } from '../../types/address';

export function getFullAddress(address: Address): string {
  return `${address?.streetName}, ${
    address?.placeName ? `${address.placeName}, ` : ''
  } ${address?.municipalityName ? `${address.municipalityName}, ` : ''} ${
    !address?.placeName && !address?.municipalityName
      ? `${address?.cityName}`
      : ''
  }`
    .trim()
    .replace(/,\s*$/, '');
}
